"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadMoreSkeleton = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constats = require("./constats");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const LoadMoreSkeleton = ({
  animation = 'pulse'
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    "data-testid": getTestId(_constats.LOAD_MORE_SKELETON),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ButtonSkeleton, {
      variant: "rectangular",
      animation: animation
    })
  });
};
exports.LoadMoreSkeleton = LoadMoreSkeleton;
